import { FormStatus } from '@app/lib/form/contracts/FormStatus';
import { FormState } from '@app/lib/form/contracts/FormState';
import { ViolationMap } from '@app/lib/form/contracts/ViolationMap';
import { ViolationMessage } from '@app/lib/form/contracts/ViolationMessage';
import { isViolationMessage } from '@app/lib/form/isViolationMessage';
import { ValidationError } from 'yup';

export function buildViolations<T>(error: ValidationError, message: string, data?: T): FormState<T> {
    return {
        status: FormStatus.Error,
        message: message,
        violations: buildViolationList([error]),
        data: data,
    };
}

function buildViolationList(errors: ValidationError[], aggregate: ViolationMap = {}): ViolationMap {
    return errors.reduce((errors, next) => {
        if (next.inner.length !== 0) {
            buildViolationList(next.inner, aggregate);
        }

        const path =
            next.path?.split('.').flatMap(key => key.split('[').map(i => (i.endsWith(']') ? i.slice(0, -1) : i))) ?? [];

        return buildViolationMap(errors, path, { message: next.message });
    }, aggregate);
}

function buildViolationMap(
    violationMap: ViolationMap,
    path: (string | number)[],
    value: ViolationMessage,
    index: number = 0,
): ViolationMap {
    if (path[index] == null) {
        return violationMap;
    }

    const current = violationMap[path[index]];

    if (isViolationMessage(current)) {
        return violationMap;
    }

    violationMap[path[index]] =
        index >= path.length - 1 ? value : buildViolationMap(current == null ? {} : current, path, value, index + 1);

    return violationMap;
}
